module.exports = __webpack_public_path__ + "static/media/add-circle.47e829e4.svg";